// libraries
import React from 'react';

import { useSelector } from 'react-redux';

// components
import ChargersTable from '../organisms/ChargersTable/ChargersTable';

const StationListPage = () => {
  const client = useSelector((state) => state?.websocket?.client ?? undefined);

  return <ChargersTable {...{ client }} />;
};

export default StationListPage;
